const rEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function SelectMechanicalWorkshopValidations(values: any) {
  let errors: any = {};

  if (!values.name) {
    errors.name = 'El nombre del taller es requerido';
  }

  if (!values.email) {
    errors.email = 'El correo electrónico es requerido';
  }

  if (!rEmail.test(values.email)) {
    errors.email = 'El email ingresado es inválido';
  }

  if (!values.phone_number) {
    errors.phone_number = 'El número de teléfono es requerido';
  }

  if (values.phone_number.length > 10) {
    errors.phone_number = 'Máximo 10 números';
  }

  return errors;
}
